<h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
<mat-dialog-content class="modal-content">
  <form [formGroup]="formData" class="grid grid-cols-2 gap-4">
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Código</mat-label>
      <input type="text" placeholder="Código" aria-label="Código" matInput [formControl]="codeControl" disabled="">
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Descripción</mat-label>
      <input type="text" placeholder="Descripción" aria-label="Descripción" matInput [formControl]="descriptionControl" readonly>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Url</mat-label>
      <input type="text" placeholder="Url" aria-label="Url" matInput [formControl]="urlControl">
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Frecuencia</mat-label>
      <mat-select [formControl]="frecuencyControl" name="frecuencyId" required>
        <mat-option *ngFor="let frecuency of frecuencyList" [value]="frecuency.value">
          {{ frecuency.fecuency }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1" *ngIf="this.frecuencyControl.value=='E'">
      <mat-label>Hora</mat-label>
      <input type="datetime" placeholder="Url" aria-label="Url" matInput [formControl]="startTimeControl">
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()"class="justify-end" [disabled]="!formData.valid">Guardar</button>
</mat-dialog-actions>  